import { Relation, Translations } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	SELECT = 'SELECT',
	CHIP = 'CHIP',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	viewType: AttributeViewType;
	listOrder: number;
	relations: Relation[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new AttributeApi();
